"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationContext = void 0;
const react_1 = require("react");
const initialState = {
    applySameAnimation: false,
    applySameDuration: true,
    animateElementsTogether: false,
    animation: '',
    animations: [],
    elements: [],
    elementAnimation: '',
    elementAnimations: {},
    groupAnimations: [],
    inOutDuration: 0,
    variant: 'default',
    labels: {
        animateElementsTogether: '',
        animationDuration: '',
        applySameAnimation: '',
        applySameDuration: '',
        beta: '',
        buttonRevertAnimation: '',
        configurationTitle: '',
        durationDisclaimer: '',
        elementWithDefaultAnimation: '',
        effectsSubTitle: '',
        emptyAnimation: '',
        groupedAnimation: '',
        pageDuration: '',
        secondsAbbreviation: '',
        tabElement: '',
        tabElementSubTitle: '',
        tabPage: '',
        title: '',
        tooltipChangeAnimation: '',
        tooltipRemoveFromGroup: '',
    },
    pageDuration: 0,
    minimumPageDuration: 0,
    selectedElements: [],
    onAnimationChange: function (animation) {
        throw new Error('Function onAnimationChange not implemented.');
    },
    onAnimationReset: function (elements) {
        throw new Error('Function onAnimationReset not implemented.');
    },
    onConfigurationChange: function (key, value) {
        throw new Error('Function onConfigurationChange not implemented.');
    },
    onElementClick: function (elements) {
        throw new Error('Function onElementClick not implemented.');
    },
    onElementMouseEnter: function (elements) {
        throw new Error('Function onElementMouseEnter not implemented.');
    },
    onElementMouseLeave: function (elements) {
        throw new Error('Function onElementMouseLeave not implemented.');
    },
};
exports.AnimationContext = (0, react_1.createContext)(initialState);
//# sourceMappingURL=AnimationContext.js.map